'use strict';

import angular from 'angular';
import {CarouselComponent} from './carousel.component';

export default angular.module('pizzutoAutopartesApp.carousel', [])
    .component(CarouselComponent.selector, CarouselComponent)
    .name;


// WEBPACK FOOTER //
// ./client/components/carousel/index.js